import { WeddingTimeline } from "./timeline";
import { Target } from "./target";
import { Date } from "./date";

import frame from "./images/рамка-2.png";

export const Announcement = () => {
  return (
    <section className="w-full ">
      <div className="relative mx-auto max-w-2xl">
        <div className="relative">
          <img src={frame} alt="Рамка" className="w-full object-contain" />

          <div className="absolute inset-x-[9%] top-[40.5%] bottom-[15%] flex flex-col items-center justify-between gap-3 sm:inset-x-[10%] sm:top-[6%] sm:bottom-[8%] sm:gap-5">
            <h2
              className="text-center text-[1.175rem] font-bold tracking-wider sm:text-lg uppercase"
              style={{ fontFamily: "ofont_flow" }}
            >
              Дорогие и близкие!
            </h2>

            <p
              className="mx-2 text-center text-xs leading-relaxed font-bold tracking-wide"
              style={{ fontFamily: "ofont_flow" }}
            >
              Скоро состоится наша свадьба. Этот важный день мы не можем
              представить без вас и хотим провести его ВМЕСТЕ!
            </p>
          </div>
        </div>

        <Date />

        <WeddingTimeline />

        <Target />
      </div>
    </section>
  );
};
